// extracted by mini-css-extract-plugin
export default {"sidebarnavigator":"sidebarnavigator_bb462681243bed2aec56","sidebar":"sidebar_d3f9c7b0b97c8ce0d2fc","container":"container_d36242ef0d5fb8ff7356"};